var a = /* @__PURE__ */ ((e) => (e.blue = "blue", e.white = "white", e))(a || {}), u = /* @__PURE__ */ ((e) => (e.small = "small", e.medium = "medium", e.large = "large", e))(u || {});
function n(e, l, r) {
  const s = ["spinner"];
  switch (e === "blue" ? s.push("spinner-blue") : s.push("spinner-white"), l) {
    case "small":
      s.push("spinner-small");
      break;
    case "large":
      s.push("spinner-large");
      break;
    default:
      s.push("spinner-medium");
      break;
  }
  return r && s.push("spinner-absolute"), s.join(" ");
}
export {
  a as ESpinnerColors,
  u as ESpinnerSizes,
  n as getSpinnerStyleClasses
};
